import React, { Component } from "react";
import { StyleSheet, View, TextInput, Text, InputAccessoryView, TouchableOpacity } from "react-native";
import { connect } from "react-redux";
import NewIssue from "../dialogs/newIssue";
import { searchInventoryTypes } from "../../actions/records";
import colors from "../../constants/colors";
import DropDown from "../widgets/dropdownMultiple"; 
import { Platform } from "react-native";
import { getIosCellHeight, getComponentSubmit, getLotCodeString, getComponentByanotherComponentId, getTotalSelected, shouldOpenLotsPickerMobile, lotFieldHasMeaningfulLots } from "../../utils";
import LotsByLocation from "../widgets/LotsByLocation";
import { isMobileWeb, getNoAutofillProps, noAutofillRef } from "../../utils/mobileWeb";
class SearchIngredientsByLot extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.initial ? props.initial : "",
            searchText: typeof props.initial == "string" ? props.initial : typeof props.initial == "object" ? getLotCodeString(props.initial) : "",
            height: 50,
            heightIOS: (props.isRecipe && Platform.OS == "ios") ? 40 : 30,
            items: [],
            wasEdited: false,
            options: props.options ? props.options : [],
            lotsSelected: props.initial ? props.initial : [],
            lastLotSelected: props.initial ? props.initial : [],
            openList: false,
            showLotsByLocation: false,
            inputAccessoryViewID: 'lot-' + props.id + '-' + props?.position,
            minorAmount: false
        };
        this._lotsViewGen = 0;
        this._embeddedLotsClosedUntil = 0;
    }

    shouldAllowEmbeddedLotsView() {
        return Date.now() >= this._embeddedLotsClosedUntil;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { isRecipe, defaultLabel, position, isInventoryReceivingForm, id, isInventoryTransfer } = this.props;
        if (nextProps.initial != this.props.initial || nextProps.rerenderTable != this.props.rerenderTable) {
            if (nextProps?.gotLotDefaultLabel && (isInventoryReceivingForm || isInventoryTransfer)) {
                this.setState({ lotsSelected: nextProps.initial });
                if(typeof nextProps.initial == "string"){
                    this.setState({ searchText: nextProps.initial });
                }else if(typeof nextProps.initial == "object"){
                    this.setState({ searchText: getLotCodeString(nextProps.initial, position) });
                    this.setState({lastLotSelected: nextProps.initial});
                }
            } else
                this.setState({ value: nextProps.initial });
        }
        if (nextProps.options != this.props.options) {
            this.setState({ options: nextProps.options });
        }
        if (nextProps.reset != this.props.reset) {
            if (defaultLabel == "lotcode" && isRecipe) {
                this.setState({ lotsSelected: nextProps.initial, lastLotSelected: nextProps.initial });
            } else
                this.setState({ value: nextProps.initial });
        }
        if (nextProps.closeSearch != this.props.closeSearch){
            this.setState({ wasEdited: false });
        }
    }
    searchItems(val) {
        const { type, searchBy, isRecipe, onSelectItem, options } = this.props;
        const { openList, lastLotSelected } = this.state;
        if (val) {
            if (searchBy == 'lot') {
                if (isRecipe) {
                    if (options) {
                        var filtered = options.filter((option) => {
                            if (option?.lot) {
                                return option.lot.toLowerCase().includes(val.toLowerCase());
                            }
                        });
                        this.setState({ options: filtered, openList: filtered?.length <= 0 ? false : true },()=>{
                            if(filtered?.length <= 0){
                                onSelectItem(val, true);
                            }
                        });
                    }
                }
            }
        } else {
            this.setState({ items: [], options: this.props.options });
            onSelectItem(lastLotSelected, true);
        }
    }
    onSelectedItemsChange(lotsSelected) {
        const { onSelectItem, initial } = this.props;
        this.setState({ lotsSelected, lastLotSelected: lotsSelected });
        //if(typeof initial == "string"){
        //    this.setState({ searchText: "" });
        //}
        onSelectItem(lotsSelected, true);
    }
    getInputRows(value){
        var valueArr = value.split('\n');
        valueArr = valueArr.length;
        if(valueArr == 0) valueArr++; else valueArr--;
        return valueArr.length;
    }
    isReceivingLotCode(defaultLabel){
        return defaultLabel == "lotcode" || defaultLabel == "lotcode_finished" || defaultLabel == "lotcode_wip";
    }
    preventModalScroll(setFormScroll, callback){
        if(setFormScroll)setFormScroll(false);
        const scheduledGen = this._lotsViewGen;
        setTimeout(() => {
          if (scheduledGen !== this._lotsViewGen) return;
          if(callback)callback();
          setTimeout(() => {
            if (scheduledGen !== this._lotsViewGen) return;
            if(setFormScroll)setFormScroll(true);
          }, 300);
        }, 300);
      }

    /** Same as iqops2: non‑iOS opens lots via Form#setShowTextBar; iOS uses embedded LotsByLocation only. */
    openLotsPickerFromInventoryPress = () => {
      const { setFormScroll, setShowTextBar, id, position, options, ingredientName, units, amount, isInventoryForm, isInventoryReceivingForm } = this.props;
      const opts = typeof options === "object" && options ? options : [];
      /* Bump gen when starting a new open so older preventModalScroll timeouts are skipped — do not bump on onBack or a pending open is aborted before setShowTextBar runs (common on web). */
      this._lotsViewGen++;
      this.preventModalScroll(setFormScroll, () => {
        if (!(isInventoryForm || isInventoryReceivingForm) || !setShowTextBar) return;
        const { lotsSelected: ls } = this.state;
        const openLotsFlag =
          (shouldOpenLotsPickerMobile(isInventoryReceivingForm, opts, opts, ingredientName, amount) ||
            lotFieldHasMeaningfulLots(ls)) &&
          this.shouldAllowEmbeddedLotsView();
        /* Mobile web (iOS or Android browser) and native Android: open KeyboardBar. Native iOS uses embedded LotsByLocation only. */
        if (isMobileWeb() || Platform.OS === "android") {
          setShowTextBar(id, position, options, ingredientName, ls, units, amount, openLotsFlag);
        }
        if (openLotsFlag) {
          this.setState({ showLotsByLocation: true });
        }
      });
    };
    render() {
        const { value, items, wasEdited, lotsSelected, options, openList, searchText, showLotsByLocation } = this.state;
        const { defaultComponent, onSelectItem, searchBy, itemInvoice_id, submission, position, isRecipe, isInvoice, isInventoryTransfer, width, openDropDown, backgroundColor, isDropDownOpened, showScanner, onFocus, id, components, setShowTextBar, scanOptionPress, ingredientName, filllocationFromLotsView, isInventoryForm, units, amount, onChange, minorAmountAndroid, minorAmount, requiredAmount, isInventoryReceivingForm, defaultLabel, isShipmentLog, isReceivingLog, setFormScroll} = this.props;
        //console.log("minorAmount :" + isRecipe + " " + minorAmount + " " + position + " " + ingredientName);
        return <View>
            {   (isInventoryForm || isInventoryReceivingForm) && showLotsByLocation ?
                <LotsByLocation units={units} amount={amount} lotsSelected={lotsSelected} options={options ? options : []} id={id} position={position} name={ingredientName} onBack={(editQty, totalSelected, minorAmount)=> {
                    this._embeddedLotsClosedUntil = Date.now() + 900;
                    setTimeout(() => {
                        this.setState({ showLotsByLocation: false, minorAmount }) 
                    }, 100);
                    //Edit Qty
                    if(
                        //!isRecipe && 
                        onChange && editQty
                    ){
                        var quantityComponent;
                        if (isShipmentLog) {
                            if (defaultLabel == "lotcode_finished") {
                                quantityComponent = getComponentByanotherComponentId(id, "quantityFinishedGoods", components);
                            } else if (defaultLabel == "lotcode_wip") {
                                quantityComponent = getComponentByanotherComponentId(id, "quantityWIP", components);
                            } else {
                                var quantityIngredient = getComponentByanotherComponentId(id, "quantityIngredient", components);
                                quantityComponent = quantityIngredient || getComponentByanotherComponentId(id, "quantityPackaging", components);
                            }
                        } else {
                            quantityComponent = getComponentByanotherComponentId(id, "quantity", components);
                        }
                        if(quantityComponent)onChange(quantityComponent.id, totalSelected, false)
                    }
                }} placeholder={"Search by lot code"} onSelect={(selected, location)=> {
                    this.onSelectedItemsChange(selected)
                    if(isRecipe && filllocationFromLotsView)filllocationFromLotsView(location)
                }}  components={components} openAlert={(value) => this.setState({ showLotsByLocation: !value })} requiredAmount={requiredAmount} isInventoryType={defaultLabel == "lotcode_finished" || defaultLabel == "lotcode_wip"} isInventoryReceivingForm={isInventoryReceivingForm} isReceivingLog={isReceivingLog} isRecipe={isRecipe}  isShipmentLog={isShipmentLog}/> : null
            }
            {
                isInventoryReceivingForm && searchBy == 'lot' ?
                    <View style={{...styles.inputContainer,
                        borderRadius: isRecipe ? 20 : 5,
                        backgroundColor: isRecipe ? minorAmount ? colors.quit : colors.primary : 'none',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        {!isInventoryReceivingForm && <TextInput
                            {...getNoAutofillProps()}
                            ref={noAutofillRef(null)}
                            value={searchText}
                            editable={!defaultComponent || !isRecipe}
                            onFocus={()=>{
                                if(onFocus)onFocus();
                            }}
                            onPress={()=>{
                                if(onFocus)onFocus();
                                this.openLotsPickerFromInventoryPress();
                            }}
                            inputAccessoryViewID={this.state.inputAccessoryViewID}
                            onContentSizeChange={(event) => {
                            }}
                            scrollEnabled={isRecipe ? false : true}
                            style={{...styles.input,
                              borderColor: "#e7e7e7",
                              borderRadius: isInventoryReceivingForm ? 20 : 5,
                              borderWidth: ((isInventoryReceivingForm && width)) ? 0 : 1,
                              color: isInventoryReceivingForm ? 'white' :"#424242",
                              fontFamily: "Roboto",
                              fontSize: isInventoryReceivingForm ? 14 :20,
                              fontWeight: "400",
                              //paddingLeft: isInventoryReceivingForm ? 5 : 10,
                              paddingBottom: 5,
                              marginTop: 5,
                              textAlign: isInventoryReceivingForm ? 'center' : 'left',
                              backgroundColor: isInventoryReceivingForm ? (minorAmount) ? colors.quit : colors.primary : 'none',
                              height: isInventoryReceivingForm ? this.state.heightIOS * this.getInputRows(searchText) :
                                Platform.OS === 'ios' ?
                                this.state.value !== '' ? this.state.heightIOS * getIosCellHeight(width, value) : this.state.heightIOS * getIosCellHeight(width, this.props.placeholder) : 
                                this.state.value !== '' ? this.state.height * getIosCellHeight(width, value) : this.state.height * getIosCellHeight(width, this.props.placeholder),
                              fontStyle: this.state.value == "" || !this.state.value ? 'italic' : 'normal',
                              flex: isInventoryReceivingForm && lotsSelected.length ? 9 : 12
                            }}
                            multiline={true}
                            placeholder={options?.length > 0 ? "Enter a lot to search" : ""}
                            placeholderTextColor={(isInventoryReceivingForm) ? 'white' :'rgb(0, 47, 108)'}
                            onChangeText={(val) => {
                                if (val == '' && this.props.placeholder == '') {
                                    this.setState({ searchText: val, height: 30, wasEdited: true });
                                } else {
                                    this.setState({ searchText: val, wasEdited: true });
                                }
                                //this.searchItems(val);
                            }}
                        />}
                        {
                            isInventoryReceivingForm && <TouchableOpacity style={{...styles.inputContainer,
                                borderRadius: isInventoryReceivingForm ? 20 : 5,
                                backgroundColor: isInventoryReceivingForm ? minorAmount ? colors.quit : colors.primary : 'none',
                                justifyContent: 'center',
                                alignItems: 'center',
                                paddingInline: 5,
                                width: '100%'
                            }}
                                onPress={() => this.openLotsPickerFromInventoryPress()}>
                                <Text style={{...styles.lotsSelectedViewTxt, borderWidth: 0}}>{searchText}</Text>
                                {lotsSelected.length > 1 && <Text style={styles.lotsSelectedViewTxt}>+{lotsSelected?.length - 1}</Text>}
                            </TouchableOpacity>
                        }
                    </View>
                    : null
            }

            {
                !isInventoryReceivingForm && searchBy == 'lot' && (options?.length > 0 || (typeof lotsSelected == "object" && lotsSelected?.length > 0)) ?
                    <DropDown
                        initialOption={lotsSelected}
                        updated={lotsSelected}
                        reset={this.props.reset}
                        options={options}
                        openList={openList}
                        defaultComponent={defaultComponent} 
                        defaultLabel={"No Lot"}
                        allLabel={"FIFO"}
                        allValue={["default_lot"]}
                        onSelect={(lots) => {
                            this.onSelectedItemsChange(lots);
                        }}
                        recipeStyle={isRecipe}
                        isRecipe={false}
                        // isRecipe={(isInvoice || isInventoryTransfer) ? false : isRecipe}
                        width={width}
                        openDropDown={openDropDown}
                        backgroundColor={backgroundColor}
                        isDropDownOpened={isDropDownOpened}
                        showScanner={showScanner}
                        showLotsByLocation={()=> {
                          if (!this.shouldAllowEmbeddedLotsView()) return;
                          this._lotsViewGen++;
                          this.setState({ showLotsByLocation: true });
                        }}
                    />
                    : null
            }
            {
                items?.length > 0 &&
                items.map(item => {
                    return <div style={styles.row}>
                        <div>
                            {searchBy == 'lot' ? item?.lot : item?.item}
                        </div>
                        <div>
                            <button style={styles.rowBtn} onClick={() => {
                                if (searchBy == 'lot') {
                                    onSelectItem(item, true);
                                } else {
                                    if (submission[itemInvoice_id]) {
                                        var exists = submission[itemInvoice_id].filter(sub => sub == item?.lot);
                                        if (exists.length > 0 && submission[itemInvoice_id][position] != item?.lot) {
                                            return;
                                        }
                                    }
                                    var newItem = item;
                                    newItem.lotSelected = ["default_lot"];
                                    onSelectItem(item, true);
                                }
                                this.setState({ items: [], value: searchBy == 'lot' ? item?.lot : item?.item, wasEdited: false });
                            }}>+</button>
                        </div>

                    </div>
                })
            }
            {
                searchText && options?.length <= 0 && wasEdited && <View>
                    <Text>No lots were found</Text>
                </View>
            }

        </View>
    }
}

export default connect((state, ownProps = {}) => ({
    isLoading: state.forms.getIn(["form", "status"]) === "loading",
}), (dispatch, props) => ({
    searchInventoryTypes: (formid, saveAsTemplate, saveAsForm, callback) =>
        dispatch(searchInventoryTypes(formid, saveAsTemplate, saveAsForm, callback)),
}))(SearchIngredientsByLot);

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        paddingTop: 5,
        flex: 1,
    },
    input: {
        borderColor: "#e7e7e7",
        borderRadius: 5,
        borderWidth: 1,
        color: "#424242",
        fontFamily: "Roboto",
        fontSize: 22,
        fontWeight: "400"
    },
    label: {
        fontSize: 20,
        color: '#939598',
        fontWeight: '300',
        fontFamily: 'Roboto',

    },
    row: {
        display: "grid",
        padding: 5,
        width: "100%",
        gridTemplateColumns: "90% 10%",
        fontFamily: "Roboto",
        fontSize: 18
    },
    rowBtn: {
        color: 'rgb(244, 152, 30)',
        border: '2px solid',
        borderRadius: 4
    },
    inputContainer:{
        flexDirection: 'row',
    },
    lotsSelectedView: { 
        flex: 3,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: colors.primary,
        color: 'white',
        borderRadius: 20,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
    },
    lotsSelectedViewTxt:{
        color: 'white',
        borderWidth: 1,
        borderRadius: 5,
        padding: 2,
        borderColor: 'white',
        fontSize: 12,
        height: 20,
        //marginRight: 3,
        marginVertical: 4
    }
});